/**
 * Created by 新思 on 2017/3/6.
 */
export default {
  getNavigationTitle: (state) => {
    return state.navigationTitle
  },
  getNavigationShow: (state) => {
    return state.navigationShow
  },
  getnowClassify: (state) => {
    return state.nowClassify
  },
  getmessageNumber: (state) => {
    return state.messageNumber
  },
  getproblem: (state) => {
    return state.problem
  },
  getcity: (state) => {
    return state.city
  },
  getpayData: (state) => {
    
    return state.payData
  },
  getingot: (state) => {
    return state.ingot
  },


}



// WEBPACK FOOTER //
// ./src/vuex/getters.js